module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"join_request":"参加リクエストを送信する","already_registered":"この会社は既に以下の情報で登録されております:","back_to_signin":"ログインに戻る","message_template":"企業の管理者にアカウントへの参加をリクエストできます","success_message":"管理者に送信された招待リクエスト","tenant_not_exists":"テナントが存在しません"}}')
  delete Component.options._Ctor
}
